<template>
<div class="div-standard-container color-D">
	<input type="hidden" id="sRoom" name="sRoom" value="UNKNOWN" v-model="sRoom" />
	<div class="font-E color-A card-header">
        <span style="margin: auto">connect with an access code</span>
    </div>
    <div class="error-text">
    	<div style="height:10px;"></div>
        <div class="error-message">
            <div class="headline">Please correct the following and try again.</div>
            <br />
            <div class="error-body">{{ error_text }}</div>
        </div>
    </div>
    <div class="connectscreen_4.1">
    	<div class="required-fields-text">
            All fields are required
        </div>
        <div class="font-C-container">
            Please enter your {{ aCustomVars['voucher_text'] }} below.
            <br><br>
            Don't have an {{ aCustomVars['voucher_text'] }} ?
            <div v-if="aCustomVars['layout']=='connectscreen_4.1'">
                <br />
            </div>
            <a href="http://www.google.com?q=<% RAND() %>">Return to options.</a>
        </div>
    </div>
    <div class="default">
    	<div class="font-F-container font-back-link" style="padding-top:20px;">
            <a href="http://www.google.com?q=">Back to options</a>
        </div>
        <div class="font-C-container">
            <span>Please enter your {{ aCustomVars['voucher_text'] }} below.</span>
        </div>
    </div>
    <div class="font-B-container guest-info-container">
        <div>
            <span class="field-label">{{ aCustomVars['voucher_text'] }}</span>
            <input class="input-field" type="text" id="sCode" name="sCode"
                   :placeholder="aCustomVars['voucher_text']"
                   :value="sCode" size="20" />
        </div>
    </div>
    <div class="radisson_red">
    	<div id="radisson-red-tos-checkbox-wrapper">
            <input type="checkbox" value="1" id="radisson-red-tos-checkbox" />
            <label for="radisson-red-tos-checkbox" class="radisson-red-tos-label">
                I agree with the T's and C's <b style="color:#e62428;">*</b>
            </label>
        </div>
    </div>
    <div class="default">
    	<div class="connect-button-inset-wrapper">
            <button class="button-0 font-E color-A connect-button">
                <div class="connectscreen_4.1" v-if="aCustomVars['layout'] == 'connectscreen_4.1'">
                    continue
                </div>
                <div v-if="aCustomVars['layout'] != 'connectscreen_4.1'">
                    connect
                </div>
            </button>
        </div>
    </div>
</div>
</template>

<script>

export default {
  name: "AccessCodeCardBody",
  data() {
    return {
        sRoom: null
    };
  }
}

</script>

<style>

</style>